/**
 * Restore previous content
 * @param {Object} state - Content state object
 * @returns {boolean} Success status
 */
export const restorePreviousContent = (state) => {
  if (state.previousContent.value) {
    state.generatedContent.value = JSON.parse(JSON.stringify(state.previousContent.value))
    return true
  }
  return false
}
